<div><h4>Post Your Job</h4></div>
<form
  name="form"
  (ngSubmit)="f.form.valid && processData()"
  #f="ngForm"
  novalidate
>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group padding-right-10">
        <!-- CAREER: DEPARTMENT -->
        <mat-form-field>
          <mat-select
            placeholder="Select department"
            [(ngModel)]="jobData.department"
            name="department"
            #department="ngModel"
            required
          >
            <mat-option
              *ngFor="let department of departmentList"
              [value]="department.value"
            >
              {{ department.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <!-- CAREER:JOB TITLE-->
        <mat-form-field>
          <input
            matInput
            placeholder="Enter job title"
            [(ngModel)]="jobData.jobPostion"
            name="title"
            #title="ngModel"
            required
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="form-group">
    <!-- CAREER:LOCATION -->
    <mat-form-field>
      <mat-select
        placeholder="Enter job location"
        [(ngModel)]="jobData.location"
        name="joblocation"
        #joblocation="ngModel"
        required
      >
        <mat-option *ngFor="let location of locationList" [value]="location.value">
          {{ location.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <!-- CAREER:JOB DISCRIPTION -->
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <div class="align-h margin-bottom-10">
          <h5 class="margin-bottom-0">Job profile</h5>
          <span>(description)</span>
        </div>
        <angular-editor
          [placeholder]
          [(ngModel)]="jobData.description"
          name="description"
          #description="ngModel"
          required
          [config]="editorConfig"
        ></angular-editor>
      </div>
    </div>
  </div>
  <!-- CAREER:JOB SKILLS -->
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <div class="align-h margin-bottom-10">
          <h5 class="margin-bottom-0">Add skills</h5>
          <span>(Add your job related keywords)</span>
        </div>
        <div
          *ngIf="skillSelection.selected?.length > 0"
          class="margin-bottom-20"
        >
          <mat-chip-list>
            <mat-chip
              color="primary"
              *ngFor="let skill of skillSelection.selected"
              (removed)="skillSelection.toggle(skill)"
            >
              {{ skill }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
        <!-- Title -->
        <mat-form-field>
          <input
            [(ngModel)]="activeskill"
            matInput
            name="activeSkill"
            type="text"
            placeholder="You can add 1 more skill"
          />
          <button
            class="margin-right-30"
            color="primary"
            mat-button
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Add Skill"
            (click)="onAddSkill()"
          >
            <mat-icon>add</mat-icon>
            <span class="padding-left-5">Add</span>
          </button>
        </mat-form-field>
      </div>
    </div>
  </div>
  <!-- CAREER:JOB SUBMIT -->
  <div class="margin-top-20 text-center">
    <button
      mat-raised-button
      color="primary"
      class="mat-button-large"
      type="submit"
      [disabled]="!f.valid"
    >
      <span *ngIf="!jobData?.id">Submit</span>
      <span *ngIf="jobData?.id">Update</span>
    </button>
  </div>
</form>
